import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Link from '@nubank/nuds-web/components/Link/Link';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

function SectionNoTaxes({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Box
      tag="section"
      backgroundColor="white"
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
    >
      <Grid
        paddingLeft={{ xs: '8x', md: '16x' }}
        paddingRight={{ xs: '8x', md: '16x' }}
        rowGap={{ xs: '6x', md: '12x' }}
        alignItems={{ lg: 'center' }}
      >
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '1 / span 6', lg: '8 / span 4' }}
        >
          <Image
            loading="lazy"
            srcSet={{
              xs: {
                '1x': 'roxinho-details-metalico/roxinho-details-metalico-xs@1x.jpg',
                '2x': 'roxinho-details-metalico/roxinho-details-metalico-xs@2x.jpg',
                '3x': 'roxinho-details-metalico/roxinho-details-metalico-xs@3x.jpg',
              },
              md: {
                '1x': 'roxinho-details-metalico/roxinho-details-metalico-md@1x.jpg',
                '2x': 'roxinho-details-metalico/roxinho-details-metalico-md@2x.jpg',
                '3x': 'roxinho-details-metalico/roxinho-details-metalico-md@3x.jpg',
              },
              lg: {
                '1x': 'roxinho-details-metalico/roxinho-details-metalico-lg@1x.jpg',
                '2x': 'roxinho-details-metalico/roxinho-details-metalico-lg@2x.jpg',
                '3x': 'roxinho-details-metalico/roxinho-details-metalico-lg@3x.jpg',
              },
            }}
            altIntlKey="CARD.NO_TAXES.IMAGE_ALT"
          />
        </Grid.Child>
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '1 / span 6', lg: '2 / span 5' }}
          gridRow={{ lg: '1' }}
        >
          <Typography
            variant="title"
            color="black"
            colorVariant="light"
            marginBottom="4x"
            intlKey={`cms.cardPage.cardCardsArea[${index}].cardSampleCardTitle`}
          />
          {formatMessage({
            id: `cms.cardPage.cardCardsArea[${index}].cardSampleCardDescription`,
          }, {
            p: props => <Typography marginBottom="5x" variant="paragraph2" {...props} />,
            a: props => (
              <Link
                typographyProps={{
                  variant: 'paragraph2',
                }}
                {...props}
              />
            ),
          })}
          <Link
            color="primary"
            href={formatMessage({ id: `cms.cardPage.cardCardsArea[${index}].cardSampleCardCtaLink` })}
            target="_blank"
            intlKey={`cms.cardPage.cardCardsArea[${index}].cardSampleCardCtaText`}
            variant="action"
          />
        </Grid.Child>

      </Grid>
    </Box>
  );
}

SectionNoTaxes.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionNoTaxes);
